'use es6';
/**
 * Flag enum of Design Asset Types.
 */

export default Object.freeze({
  NONE: 0,
  LAYOUT: 1,
  TEMPLATE: 2,
  CUSTOM_WIDGET: 4,
  GLOBAL_GROUP: 8,
  GLOBAL_WIDGET: 16
});